import { render, staticRenderFns } from "./mod-logo.vue?vue&type=template&id=673115b7"
import script from "./mod-logo.vue?vue&type=script&lang=js"
export * from "./mod-logo.vue?vue&type=script&lang=js"
import style0 from "./_scss/logo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports